import React from 'react';
import { useAuth } from '../../context/AuthContext';

const Header: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        background: '#ffffff',
        borderBottom: '1px solid #e2e8f0',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      }}
    >
      {/* Indigo accent line */}
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, height: 3,
        background: 'linear-gradient(90deg, #312e81, #4f46e5, #6366f1, #818cf8)',
        backgroundSize: '200% 100%',
        animation: 'header-shimmer 4s ease-in-out infinite',
      }} />

      <style>{`
        @keyframes header-shimmer {
          0%, 100% { background-position: 0% 50%; }
          50%       { background-position: 100% 50%; }
        }
      `}</style>

      <div className="h-16 w-full px-gutter-normal flex items-center justify-between gap-space-lg">

        {/* Logo */}
        <div className="flex items-center gap-space-lg flex-shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center"
              style={{ background: 'rgba(79,70,229,0.1)', border: '1px solid rgba(79,70,229,0.2)' }}>
              <span className="material-symbols-outlined text-[18px]" style={{ color: '#4f46e5' }}>newspaper</span>
            </div>
            <span className="font-display text-headline-sm hidden sm:block" style={{ color: '#0f172a', letterSpacing: '0.02em' }}>
              AlCircle
            </span>
          </div>
          <div className="hidden xl:flex items-center gap-space-sm pl-space-md">
            <div className="inline-flex items-center gap-space-xs px-2.5 py-1 rounded-full font-mono text-label-xs"
              style={{ background: 'rgba(16,185,129,0.08)', color: '#059669', border: '1px solid rgba(16,185,129,0.2)' }}>
              <span className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ background: '#10b981' }} />
              <span>Live</span>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={logout}
            className="w-8 h-8 rounded-full flex items-center justify-center transition-colors"
            style={{ background: '#f1f5f9', color: '#64748b', border: '1px solid #e2e8f0' }}
            onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = '#e2e8f0'; (e.currentTarget as HTMLElement).style.color = '#0f172a'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = '#f1f5f9'; (e.currentTarget as HTMLElement).style.color = '#64748b'; }}
            title={`Logout (${user?.email})`}
          >
            <span className="material-symbols-outlined text-[18px]">person</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
